<template>
    <div class="intro">
        <video ref="videoRef" class="intro__video" src="" autoplay="true" muted="muted" loop></video>
        <svg version="1.1" id="wiesel" class="intro__wiesel" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42.9 35.3" style="enable-background:new 0 0 42.9 35.3;" xml:space="preserve">
            <path class="st0" d="M37.1,29.6C37.1,29.5,37.2,29.6,37.1,29.6 M42.3,3.9c0,0-1.8-1.1-2.1-1.2c-0.3-0.1,0-0.4-0.6-0.4
                c-0.2,0-1-0.4-2-0.6c-0.1-0.4-0.2-0.9-0.1-1.1c0.1-0.4,0.2-0.4-0.1-0.4c-0.2,0-1.1,0.8-1.5,1.2c-0.7-0.1-1.5-0.1-2.3,0.1
                c-0.5-0.2-1.8-0.8-2.2-0.5c-0.5,0.4-0.6,1.6-0.5,2.2c-0.2,0.3-0.4,0.6-0.6,0.9c0,0-0.8,1.5-0.7,3.6c-0.1,0.8-0.1,2,0.2,2.4
                c0.3,0.4,0,0.2,0.1-0.5c0,0.1,0,0.1,0,0.2c1,3.2,1.2,4.5,0.3,5.5c-0.8,0.9-2.4,1.1-2.4,1.1s-1-0.8-2.4-1.7c-0.5-0.7-1.3-1.6-1.7-1.7
                c-0.6-0.2,0.1-0.1,0.4,0.9c-1.6-0.9-3.3-1.8-4.7-2.1c-1.3-0.2-3.6-0.3-5.9,0.5c-0.6,0.1-2.5,0.5-2.9,0.9c-0.4,0.5-0.1-0.1,0.8,0
                c-2.6,1.6-4.8,4.5-4.8,9.9c-0.1,0.4-0.2,0.9-0.2,1.4c-1.8,0.5-3.1,1.4-3.7,2c-0.5,0.5-0.9,1-1.2,1.5c-0.5,0.7-1.2,1.7-1.2,2.2
                c0,0.6-0.1,0,0.6-0.5c0,0.3,0,0.6,0.1,1l-0.1,0c0,0,1.1,2.4,1.8,2.7c0.6,0.2,0,0.1-0.2-0.7c0.3,0.2,0.7,0.5,1.1,0.7
                c0.6,0.5,1.4,1.1,1.8,1.1c0.5,0,0.1,0.1-0.3-0.4c0.4,0.2,0.9,0.3,1.4,0.5c1.2,0.4,2.2,0.7,3.1,0.8l-0.1,0.1c0,0,0.1,0,0.3,0
                c1.3,0.1,2,0.1,2.4-0.3c0.2-0.1,0.4-0.4,0.5-0.4c0.3-0.3,0.2-0.1-0.2-0.1c0.4-0.9-0.7-2.3-2.2-2.6c-4.2-1-5.9-4.4-3-5.6
                c0.5,1.5,1.2,3.1,2.1,3.8c1.8,1.3,4.3,1.6,4.3,1.6s-0.2-0.6,0.3-0.3c0.6,0.3,1.1,0.3,1.3,0.3c0.2,0,0.9-0.2,1.1-0.2
                c0.2,0,0-0.8,0.8-0.7l-0.5-0.8h1.3l0.2-0.1l0.9-0.1c0,0-0.1-1.1-1.1-1.1c-1,0,0.9-0.4,1.6-1.1c0.7-0.6,1.4-2.3,3-2.1
                c1.6,0.2,2,1.4,4.7,1.3c0,0,2.1,2.1,3.1,2.7c0.9,0.6,2.4,0.6,2.4,0.6h0.8l0.4-0.1l0.4-0.4c0,0,0.3,0.5,0.6,0.5
                c0.3,0,1.2,0.2,1.2,0.2l0.1-0.5c0,0,0.9-0.1,1.2,0c-0.1-0.4,0-0.1-0.2-0.6h1.2c0,0-0.8-1.2-1.4-1.2c-0.6,0-0.6-0.3-0.6-0.3
                s-0.1-0.3-0.9-0.1c-0.8,0.3-0.9-0.4-0.9-0.4s-0.3-0.6-0.2-1.1c0.1-0.6,0.1-0.6,0.1-0.6s1.8-0.4,2.9-4.1c0,0,0.5-1.3,1-2.4
                c0.1,0.9-0.5,1.1,0,0.7c0.4-0.3,0.6-1.4,0.8-2.2c0.5-1.2,0.8-3.7,0-5.5c-0.5-1.2-1.2-2.8-0.6-3.2c0.7-0.3,1.6-0.3,1.9-0.5
                c0.7-0.4,0.8-0.4,1.5-1.2C42.8,5.9,43.1,4.2,42.3,3.9z"/>
        </svg>

    </div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/hessestudios/hessesettings'
    });
    export default {
        name: 'Intro',
        data(){
            return {
                video : ""
            };
        },
        mounted(){
            ax.get().then(response => {
                this.$refs.videoRef.src = response.data.hesse_field_video;
                this.$refs.videoRef.play();
            });
        }
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/intro.scss";
                          .st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-linejoin:round;}
</style>